import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EditProgramStore } from "../components/edit-program/store";
import { ProgramListStoreModule } from "../components/program-list/store";

@NgModule({
  imports: [CommonModule, EditProgramStore, ProgramListStoreModule],
})
export class ProgramsStoreModule {}
